import { Accordion } from "./components/Accordion/index.js";
import { ActionIcon } from "./components/ActionIcon/index.js";
import { jsx, Fragment } from "react/jsx-runtime";
import { useState, useLayoutEffect } from "react";
import { DEFAULT_PORTAL_ID } from "./constants/config.js";
import { AS, AirfoilStyles } from "./components/AirfoilStyles/index.js";
import { AnimatedItem } from "./components/AnimatedItem/index.js";
import { AnimationSpinner } from "./components/AnimationSpinner/index.js";
import { Avatar } from "./components/Avatar/index.js";
import { NumericalBadge, TextBadge } from "./components/Badge/index.js";
import { Button } from "./components/Button/index.js";
import { Checkbox, CheckboxInput } from "./components/Checkbox/index.js";
import { Chip } from "./components/Chip/index.js";
import { ControlContainer } from "./components/ControlContainer/index.js";
import { TimeBadge } from "./components/DepartureItems/TimeBadge/index.js";
import { Drawer } from "./components/Drawer/index.js";
import { Font } from "./components/Font/index.js";
import { IconContainer } from "./components/IconContainer/index.js";
import { Icons24CircleFlag } from "./components/Icons24/Icons24CircleFlag/index.js";
import { Icons24Fod } from "./components/Icons24/Icons24Fod/index.js";
import { Icons24Hand } from "./components/Icons24/Icons24Hand/index.js";
import { Icons24Placeholder } from "./components/Icons24/Icons24Placeholder/index.js";
import { Icons24ReadyFlight } from "./components/Icons24/Icons24ReadyFlight/index.js";
import { Icons24StarFlight } from "./components/Icons24/Icons24StarFlight/index.js";
import { Icons24 } from "./components/Icons24Sprite/index.js";
import { IconWrapper } from "./components/IconWrapper/index.js";
import { IndexActionTray } from "./components/IndexTable/IndexActionTray/index.js";
import { IndexPanelActionPanel } from "./components/IndexTable/IndexPanelActionPanel/index.js";
import { IndexTableCellBadge } from "./components/IndexTable/IndexTableCellBadge/index.js";
import { IndexTableCellFlight } from "./components/IndexTable/IndexTableCellFlight/index.js";
import { IndexTableCellIcon } from "./components/IndexTable/IndexTableCellIcon/index.js";
import { IndexTableCellProgress } from "./components/IndexTable/IndexTableCellProgress/index.js";
import { IndexTableCellText } from "./components/IndexTable/IndexTableCellText/index.js";
import { IndexTableCellWrapper } from "./components/IndexTable/IndexTableCellWrapper/index.js";
import { IndexTableContext, useIndexTableDisabled } from "./components/IndexTable/IndexTableContext.js";
import { IndexTableHeader } from "./components/IndexTable/IndexTableHeader/index.js";
import { IndexTableRowWrapper } from "./components/IndexTable/IndexTableRowWrapper/index.js";
import { ButtonField, ComboboxField, InputField } from "./components/InputFields/InputField/index.js";
import { Rate } from "./components/InputFields/Rate/index.js";
import { TextArea } from "./components/InputFields/TextArea/index.js";
import { Logo } from "./components/Logo/index.js";
import { M } from "./index-2Hivfe91.js";
import { a, O } from "./index-B9oEyfz4.js";
import { QAPanelButton } from "./components/QAPanelButton/index.js";
import { Radio } from "./components/Radio/index.js";
import { SegmentedControl } from "./components/SegmentedControl/index.js";
import { SideNavigation } from "./components/SideNavigation/index.js";
import { Spinner } from "./components/Spinner/index.js";
import { SVGPane } from "./components/SVGPane/index.js";
import { Switch } from "./components/Switch/index.js";
import { Tab, Tabs } from "./components/Tabs/index.js";
import { Tile } from "./components/Tile/index.js";
import { TileHeader } from "./components/TileHeader/index.js";
import { TimeCell } from "./components/TimeCell/index.js";
import { TimePanel } from "./components/TimePanel/index.js";
import { a as a2, b, T, c } from "./constants-mfGraMO4.js";
import { b as b2, T as T2, a as a3, u, w } from "./hooks-DLGF6ofZ.js";
import { Tooltip } from "./components/Tooltip/index.js";
import { TurnaroundFrame } from "./components/TurnaroundFrame/index.js";
import { Video } from "./components/Video/index.js";
import { LiveBadge } from "./components/Video/LiveBadge/index.js";
import { VideoTimeline } from "./components/Video/VideoTimeline/index.js";
import { ThemeSlot, withThemeAndSize } from "./components/withThemeAndSize/index.js";
import { INTENT } from "./constants/intent.js";
import { SIZE } from "./constants/size.js";
import { THEME } from "./constants/theme.js";
import { useAnimationClass } from "./hooks/useAnimationClass.js";
import { useAnimationFrame } from "./hooks/useAnimationFrame.js";
import { B, a as a4 } from "./constants-BLwk9iaK.js";
import './assets/main.css';const AirfoilRoot = ({ doNotCreateDefaultPortal = false, children }) => {
  const [mounted, setMounted] = useState(false);
  useLayoutEffect(() => {
    setMounted(true);
    if (doNotCreateDefaultPortal) {
      return;
    }
    const newElement = document.createElement("div");
    newElement.id = DEFAULT_PORTAL_ID;
    newElement.classList.add("assaia-ui-portal");
    document.body.appendChild(newElement);
    return () => {
      document.body.removeChild(newElement);
    };
  }, []);
  if (!mounted) {
    return null;
  }
  return /* @__PURE__ */ jsx(Fragment, { children });
};
export {
  AS,
  Accordion,
  ActionIcon,
  AirfoilRoot,
  AirfoilStyles,
  AnimatedItem,
  AnimationSpinner,
  Avatar,
  B as BUTTON_INTENT,
  a4 as BUTTON_INTENT_CLASSNAME_MAP,
  Button,
  ButtonField,
  Checkbox,
  CheckboxInput,
  Chip,
  ComboboxField,
  ControlContainer,
  DEFAULT_PORTAL_ID,
  Drawer,
  Font,
  INTENT,
  IconContainer,
  IconWrapper,
  Icons24,
  Icons24CircleFlag,
  Icons24Fod,
  Icons24Hand,
  Icons24Placeholder,
  Icons24ReadyFlight,
  Icons24StarFlight,
  IndexActionTray,
  IndexPanelActionPanel,
  IndexTableCellBadge,
  IndexTableCellFlight,
  IndexTableCellIcon,
  IndexTableCellProgress,
  IndexTableCellText,
  IndexTableCellWrapper,
  IndexTableContext,
  IndexTableHeader,
  IndexTableRowWrapper,
  InputField,
  LiveBadge,
  Logo,
  M as Modal,
  NumericalBadge,
  a as OptionItem,
  O as OptionList,
  QAPanelButton,
  Radio,
  Rate,
  SIZE,
  SVGPane,
  SegmentedControl,
  SideNavigation,
  Spinner,
  Switch,
  THEME,
  a2 as TOAST_INTENT,
  b as TOAST_INTENT_CLASSNAME_MAP,
  T as TOAST_TYPE,
  c as TOAST_TYPE_CLASSNAME_MAP,
  Tab,
  Tabs,
  TextArea,
  TextBadge,
  ThemeSlot,
  Tile,
  TileHeader,
  TimeBadge,
  TimeCell,
  TimePanel,
  b2 as Toast,
  T2 as ToastContext,
  a3 as ToastProvider,
  Tooltip,
  TurnaroundFrame,
  Video,
  VideoTimeline,
  useAnimationClass,
  useAnimationFrame,
  useIndexTableDisabled,
  u as useToast,
  withThemeAndSize,
  w as withToastProvider
};
